/* eslint-disable */
export default {
  board: {
    clear: {
      "IT": "Pulisci tutto",
      "EN": "Clear",
      "DE": "Klar"
    },
    colorPicker: {
      "IT": "Pennello",
      "EN": "Brush",
      "DE": "Pinsel"
    },
    eraser: {
      "IT": "Gomma",
      "EN": "Eraser",
      "DE": "Radiergummi"
    },
    send: {
      "IT": "Invia",
      "EN": "Send",
      "DE": "Shiff"
    },
    sizePicker: {
      "IT": "Dimensione",
      "EN": "Size",
      "DE": "Größe"
    }
  },
  error: {
    cantSend: {
      "IT": "Non sono riuscito a inviare il messaggio",
      "EN": "I couldn't send your message",
      "DE": "Ich konnte die Nachricht nicht senden"
    },
    emptyDraw: {
      "IT": "Non posso inviare un foglio bianco!",
      "EN": "I can not send an empty message!",
      "DE": "Ich kann kein leeres Blatt schicken!"
    }
  },
  lang: [
    "IT",
    "EN",
    "DE"
    ],
  send: {
    sendBtn: {
      "IT": "Invia",
      "EN": "Send",
      "DE": "Shiff"
    },
    input: {
      title: {
        "IT": "Il tuo nome",
        "EN": "Your name",
        "DE": "Dein Name"
      },
      description: {
        "IT": "Il tuo messaggio",
        "EN": "Your message",
        "DE": "Dein Name"
      },
      from: {
        "IT": "Da dove vieni?",
        "EN": "Where are you from?",
        "DE": "Woher kommst du?"
      }
    },
    title: {
      "IT": "Inviaci il tuo messaggio",
      "EN": "Send us your message",
      "DE": "Deine Nachricht"
    }
  },
  sent: {
    "IT": "Grazie!",
    "EN": "Thank you!",
    "DE": "Danke!"
  },
  layout: {
    IT: {
      _meta: {
        "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
        "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
        "space": { key: " ", text: "Spazio", width: 180},
        "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
        "backspace": { func: "backspace", classes: "control backspace", width: 65},
        "accept": { func: "accept", text: "Invia", classes: "control featured"},
        "next": { func: "next", text: "Prossimo", classes: "control featured"}
      },
  
      default: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} q w e r t y u i o p è + {enter}",
        "{caps} a s d f g h j k l ò à ù",
        "{shiftl} < z x c v b n m , . - {shiftr}",
        "{next} {space} {accept}"
      ],
      shifted: [
        "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
        "{tab} Q W E R T Y U I O P é * {enter}",
        "{caps} A S D F G H J K L ç ° §",
        "{shiftl} > Z X C V B N M ; : _ {shiftr}",
        "{next} {space} {accept}"
      ],
      
      capsed: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} Q W E R T Y U I O P è + {enter}",
        "{caps} A S D F G H J K L ò à ù",
        "{shiftl} < Z X C V B N M , . - {shiftr}", 
        "{next} {space} {accept}"
      ]		
    },
    EN: {
      _meta: {
        "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
        "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
        "space": { key: " ", text: "Space", width: 180},
        "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
        "backspace": { func: "backspace", classes: "control backspace", width: 65},
        "accept": { func: "accept", text: "Send", classes: "control featured"},
        "next": { func: "next", text: "Next", classes: "control featured"}
      },
  
      default: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} q w e r t y u i o p [ ] \\",
        "{caps} a s d f g h j k l ; ' {enter}",
        "{shiftl} z x c v b n m , . / {shiftr}",
        "{next} {space} {accept}"
      ],
      shifted: [
        "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
        "{tab} Q W E R T Y U I O P { } |",
        "{caps} A S D F G H J K L : \" {enter}",
        "{shiftl} Z X C V B N M < > ? {shiftr}",
        "{next} {space} {accept}"
      ],
      
      capsed: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} Q W E R T Y U I O P [ ] \\",
        "{caps} A S D F G H J K L ; ' {enter}",
        "{shiftl} Z X C V B N M , . / {shiftr}", 
        "{next} {space} {accept}"
      ]		
    },
    DE: {
      _meta: {
        "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
        "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
        "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
        "space": { key: " ", text: "Space", width: 180},
        "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
        "backspace": { func: "backspace", classes: "control backspace", width: 65},
        "accept": { func: "accept", text: "Send", classes: "control featured"},
        "next": { func: "next", text: "Folgende", classes: "control featured"}
      },
  
      default: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} q w e r t y u i o p [ ] \\",
        "{caps} a s d f g h j k l ; ' {enter}",
        "{shiftl} z x c v b n m , . / {shiftr}",
        "{next} {space} {accept}"
      ],
      shifted: [
        "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
        "{tab} Q W E R T Y U I O P { } |",
        "{caps} A S D F G H J K L : \" {enter}",
        "{shiftl} Z X C V B N M < > ? {shiftr}",
        "{next} {space} {accept}"
      ],
      
      capsed: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
        "{tab} Q W E R T Y U I O P [ ] \\",
        "{caps} A S D F G H J K L ; ' {enter}",
        "{shiftl} Z X C V B N M , . / {shiftr}", 
        "{next} {space} {accept}"
      ]		
    }
  }
};